import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'
import { showFilterModal } from 'actions/filterModal'
import withType from 'components/common/hoc/withType'
import { getHasActiveVehicleStatus } from 'selectors'
import { setFiltersData } from '../../actions'
import { updateQuery } from '../actions'
import { getCompatibilityFilterValue } from '../selectors'
import BrandGuidedNavigation from './BrandGuidedNavigation'

const withDataSet = lifecycle({
  componentDidMount() {
    this.props.setFiltersData(this.props.navigation)
  },
  componentDidUpdate({ navigation }) {
    if (this.props.navigation !== navigation) {
      this.props.setFiltersData(this.props.navigation)
    }
  }
})

const mapStateToProps = state => ({
  compatibilityFilter: getCompatibilityFilterValue(state),
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

export default compose(
  withType({ type: 'BrandGuidedNavigation', placeholders: ['navigation']}),
  connect(mapStateToProps, { setFiltersData, updateQuery, showFilterModal }),
  withDataSet
)(BrandGuidedNavigation)
